import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import dashboardService from '../services/dashboardService';
import { CounsellorData, ClientUser } from '../types/dashboard.types';

interface DashboardState {
    counsellor: CounsellorData | null;
    clients: ClientUser[];
    totalClients: number;
    loading: boolean;
    error: string | null;
}

const initialState: DashboardState = {
    counsellor: null,
    clients: [],
    totalClients: 0,
    loading: false,
    error: null,
};

export const fetchCounsellorProfile = createAsyncThunk(
    'dashboard/fetchCounsellorProfile',
    async () => {
        const response = await dashboardService.getCounsellorProfile();
        return response.data;
    }
);

export const fetchClients = createAsyncThunk(
    'dashboard/fetchClients',
    async () => {
        const response = await dashboardService.getClients();
        return response.data || response;
    }
);

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCounsellorProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCounsellorProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.counsellor = action.payload;
            })
            .addCase(fetchCounsellorProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch profile';
            })
            .addCase(fetchClients.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchClients.fulfilled, (state, action) => {
                state.loading = false;
                state.clients = action.payload?.users || action.payload?.data?.users || [];
                state.totalClients = action.payload?.total || action.payload?.data?.total || 0;
            })
            .addCase(fetchClients.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch clients';
            });
    },
});

export default dashboardSlice.reducer;
